(() => {
  const selector = [
    '.announcement-bar',
    '.badge.onsale',
    '.background-video__content',
    '.cart-drawer--discount',
    '.gallery__item-content-heading',
    '.image-with-text-overlay .button',
    '.image-with-text-overlay--heading',
    '.media-grid--heading',
    '.promotion-bar',
    '.section-header--title',
    '.slideshow__slide-heading'
  ].join(',');

  const percentagePattern = /\d[\d.,]*\s?%/gu;

  function isolatePercentages(root = document) {
    root.querySelectorAll(selector).forEach((container) => {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      const textNodes = [];

      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (node.parentElement?.closest('bdi, .rtl-number-isolate')) continue;
        if (percentagePattern.test(node.nodeValue || '')) textNodes.push(node);
        percentagePattern.lastIndex = 0;
      }

      textNodes.forEach((node) => {
        const text = node.nodeValue || '';
        const fragment = document.createDocumentFragment();
        let lastIndex = 0;

        text.replace(percentagePattern, (match, offset) => {
          fragment.append(text.slice(lastIndex, offset));
          const isolate = document.createElement('bdi');
          isolate.className = 'rtl-number-isolate';
          isolate.dir = 'ltr';
          isolate.textContent = match;
          fragment.append(isolate);
          lastIndex = offset + match.length;
          return match;
        });

        fragment.append(text.slice(lastIndex));
        node.replaceWith(fragment);
      });
    });
  }

  isolatePercentages();
  document.addEventListener('shopify:section:load', (event) => isolatePercentages(event.target));
})();
